<!--
  This loader is now controlled by Angular. It shows when the app starts
  or when navigating between pages, preventing a "white screen" without
  blocking the initial page paint.
-->
@if (isLoading) {
  <div class="app-loader">
    <!-- Your existing SVG loader -->
    <svg data-name="Layer 2" viewBox="0 0 247.33 100.59" xmlns="http://www.w3.org/2000/svg">
      <g data-name="Layer 1">
        <path class="cls-2" d="M126.33,56.15h6.78c.45,4.84,3.59,7.69,8.58,7.69s7.98-2.03,7.98-5.42c0-4.16-4.39-4.79-9.23-5.52-6.09-.82-13.12-1.84-13.12-9.77,0-6.97,5.29-10.74,14.22-10.74,8.13,0,13.42,4.64,14.12,12.48h-6.83c-.3-4.5-3.14-7.16-7.63-7.16s-6.88,1.84-6.88,4.93c0,3.53,4.09,4.16,8.68,4.84,6.24.87,13.67,1.98,13.67,10.26,0,7.16-5.59,11.42-15.11,11.42-8.88,0-14.52-4.79-15.21-13.01Z"/>
        <path class="cls-2" d="M186.18,44.4v24.29h-6.58v-8.37h-.1c0,5.56-3.34,8.85-8.93,8.85-6.28,0-9.98-4.69-9.98-12.63s3.69-12.63,9.98-12.63c5.59,0,8.93,3.29,8.93,8.81h.1v-8.32h6.58ZM179.94,56.54c0-4.5-2.34-7.6-6.33-7.6s-6.33,2.85-6.33,7.6,2.34,7.55,6.33,7.55,6.33-3.1,6.33-7.55Z"/>
        <path class="cls-2" d="M200.64,48.8v11.71c0,2.27,1.5,3.58,3.99,3.58,1.2,0,2.44-.29,3.34-.77v4.74c-1.5.68-3.54,1.11-5.44,1.11-5.34,0-8.48-2.9-8.48-7.84v-12.53h-3.59v-4.4h3.99v-8.13h6.58v2.03c0,3.1-2.39,5.27-6.38,6v.1h13.77v4.4h-7.78Z"/>
        <path class="cls-2" d="M235.66,57.26h-18.26c.25,4.45,2.44,7.06,5.99,7.06,3.09,0,5.24-1.64,5.89-4.31h6.38c-.9,5.76-5.49,9.14-12.27,9.14-7.78,0-12.37-4.69-12.37-12.63s4.59-12.63,12.27-12.63,12.27,4.64,12.27,12.63v.73ZM217.45,55.09h11.77c-.4-4.06-2.54-6.39-5.84-6.39s-5.49,2.32-5.94,6.39Z"/>
        <path class="cls-2" d="M240.74,31.43h6.58v37.25h-6.58V31.43Z"/>
        <path class="cls-3" d="M114.41,40.3H31.65C14.17,40.3,0,53.8,0,70.45c0,3.54.64,6.94,1.82,10.1h82.58v-.07s.06,0,.08,0c17.53,0,31.73-13.5,31.73-30.15,0-3.52-.64-6.89-1.8-10.03ZM84.43,70.41s.03,0,0,0h0l-43.08-.03H10.55c.04-11.07,9.47-19.98,21.1-19.98h0l73.98.06c-.07,11.04-9.57,19.95-21.2,19.95Z"/>
        <path class="cls-4" d="M94.95,21.99v-.13c-3.26-1.08-6.75-1.67-10.39-1.68h0s-.05,0-.07,0c-.55,0-1.09.01-1.63.04-.17,0-.34.03-.52.04-.36.02-.73.04-1.09.08-.23.02-.46.06-.69.08-.3.03-.59.06-.89.11-.25.04-.51.08-.76.13-.27.04-.53.08-.8.14-.26.05-.52.11-.77.17-.25.06-.51.1-.75.17-.27.07-.55.14-.82.22-.23.06-.45.12-.68.18-.29.09-.58.18-.87.28-.2.06-.4.12-.59.19-.3.1-.6.22-.9.33-.18.07-.36.13-.54.2-.31.12-.61.26-.91.39-.16.07-.32.14-.48.21-.32.14-.63.3-.94.45-.14.07-.28.13-.42.21-.33.17-.65.34-.96.52-.12.07-.24.13-.35.19-.33.19-.66.39-.99.59-.1.06-.2.12-.29.18-.34.22-.67.44-1,.67-.08.05-.16.1-.24.16-.34.24-.67.49-1,.74-.06.05-.13.09-.19.14-.34.26-.67.54-1,.81-.05.04-.1.08-.14.12-.34.29-.67.59-1,.89-.03.03-.07.06-.1.09-.34.32-.66.64-.99.97-.02.02-.04.04-.06.06-.33.34-.65.69-.97,1.05,0,0-.02.02-.03.03-.32.36-.63.74-.94,1.12,0,0,0,0,0,0-3.97,4.96-6.35,11.12-6.44,17.81h-.01v20.51h0s0,.01,0,.02c0,11.1-9.45,20.1-21.1,20.1-3.84,0-7.45-.98-10.55-2.69v11.02c3.3,1.11,6.85,1.72,10.55,1.72,17.47,0,31.64-13.49,31.65-30.13h0v-20.01h.03s0-.09,0-.13c0-4.14,1.32-7.99,3.58-11.19.04-.06.09-.12.14-.19.3-.42.62-.82.95-1.21.1-.11.19-.23.29-.34.38-.43.78-.85,1.2-1.25.05-.04.1-.09.15-.13.39-.36.79-.7,1.2-1.04.12-.09.23-.19.35-.28.46-.36.94-.7,1.44-1.02.04-.03.09-.05.13-.08.46-.29.94-.56,1.43-.82.13-.07.27-.14.41-.21.53-.27,1.08-.52,1.64-.75.03-.01.07-.02.1-.04.53-.21,1.08-.4,1.63-.57.15-.05.3-.09.45-.13.59-.17,1.19-.32,1.8-.44.02,0,.04,0,.06,0,.59-.11,1.2-.2,1.81-.26.16-.02.32-.03.48-.05.64-.05,1.28-.09,1.93-.09.02,0,.05,0,.07,0v10.06h10.48v-18.3h-.08Z"/>
        <path class="cls-1" d="m31.66 40.33v-9.72c0-0.15-0.01-0.29-0.01-0.44 0-11.11 9.45-20.11 21.11-20.11 0.6 0 1.18 0.03 1.77 0.08h-1.72v10.16h10.48v-7.56s0.02 0 0.03 0.01v-11.03c-3.3-1.11-6.85-1.72-10.56-1.72-17.49 0-31.67 13.51-31.67 30.17v0.06 60.08l10.48 0.24 0.04-40.14 0.05-10.08z"/>
      </g>
    </svg>
  </div>
}

<!--
  The main application view is now wrapped in a conditional block.
  It will only be rendered once the initial route has finished loading.
-->
@if (!isLoading) {
  <ion-split-pane when="never" contentId="main-content">
    @defer {
      <ion-menu contentId="main-content" menuId="mainNav" class="main-nav">
        <ion-header>
          <ion-toolbar>
            <app-logo height="36px" slot="start"></app-logo>
            <ion-buttons slot="end">
              <ion-menu-toggle menu="mainNav">
                <ion-button>
                  <ion-icon name="close"></ion-icon>
                </ion-button>
              </ion-menu-toggle>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content [fullscreen]="true">
          <app-mobile-nav></app-mobile-nav>
        </ion-content>
      </ion-menu>
    }

    @defer {
      <ion-menu menuId="filter-menu"
                class="filter-menu"
                side="end"
                draggable="false"
                contentId="main-content">
        <ion-header>
          <ion-toolbar>
            <ion-title>Filter </ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <app-mobile-filter-menu></app-mobile-filter-menu>
        </ion-content>
      </ion-menu>
    }

    <div class="ion-page" id="main-content">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>

  <app-performance-monitor></app-performance-monitor>
}
